import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const fetchVehicleTypes = createAsyncThunk(
    'vehicleTypes/fetchVehicleTypes',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getVehicleTypesPaginated(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch vehicle types');
        }
    }
);

export const getVehicleTypesOverview = createAsyncThunk(
    'vehicleTypes/getVehicleTypesOverview',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getVehicleTypesOverview();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch vehicle types overview');
        }
    }
);

export const createVehicleTypeAsync = createAsyncThunk(
    'vehicleTypes/createVehicleType',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await apiService.createVehicleType(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create vehicle type');
        }
    }
);

export const updateVehicleTypeAsync = createAsyncThunk(
    'vehicleTypes/updateVehicleType',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await apiService.updateVehicleType(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update vehicle type');
        }
    }
);

export const deleteVehicleTypeAsync = createAsyncThunk(
    'vehicleTypes/deleteVehicleType',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.deleteVehicleType(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete vehicle type');
        }
    }
);

const initialState = {
    vehicleTypesData: null,
    vehicleTypesLoading: false,
    vehicleTypesError: null,
    vehicleTypesOverview: null,
    vehicleTypesOverviewLoading: false,
    createVehicleTypeLoading: false,
    updateVehicleTypeLoading: false,
    deleteVehicleTypeLoading: false,
};

const vehicleTypeSlice = createSlice({
    name: 'vehicleTypes',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVehicleTypes.pending, (state) => {
                state.vehicleTypesLoading = true;
                state.vehicleTypesError = null;
            })
            .addCase(fetchVehicleTypes.fulfilled, (state, action) => {
                state.vehicleTypesLoading = false;
                state.vehicleTypesData = action.payload?.data || null;
                state.vehicleTypesError = null;
            })
            .addCase(fetchVehicleTypes.rejected, (state, action) => {
                state.vehicleTypesLoading = false;
                state.vehicleTypesError = action.payload;
                state.vehicleTypesData = null;
            })
            .addCase(getVehicleTypesOverview.pending, (state) => {
                state.vehicleTypesOverviewLoading = true;
            })
            .addCase(getVehicleTypesOverview.fulfilled, (state, action) => {
                state.vehicleTypesOverviewLoading = false;
                state.vehicleTypesOverview = action.payload?.data || null;
            })
            .addCase(getVehicleTypesOverview.rejected, (state) => {
                state.vehicleTypesOverviewLoading = false;
            })
            .addCase(createVehicleTypeAsync.pending, (state) => {
                state.createVehicleTypeLoading = true;
            })
            .addCase(createVehicleTypeAsync.fulfilled, (state) => {
                state.createVehicleTypeLoading = false;
            })
            .addCase(createVehicleTypeAsync.rejected, (state) => {
                state.createVehicleTypeLoading = false;
            })
            .addCase(updateVehicleTypeAsync.pending, (state) => {
                state.updateVehicleTypeLoading = true;
            })
            .addCase(updateVehicleTypeAsync.fulfilled, (state) => {
                state.updateVehicleTypeLoading = false;
            })
            .addCase(updateVehicleTypeAsync.rejected, (state) => {
                state.updateVehicleTypeLoading = false;
            })
            .addCase(deleteVehicleTypeAsync.pending, (state) => {
                state.deleteVehicleTypeLoading = true;
            })
            .addCase(deleteVehicleTypeAsync.fulfilled, (state) => {
                state.deleteVehicleTypeLoading = false;
            })
            .addCase(deleteVehicleTypeAsync.rejected, (state) => {
                state.deleteVehicleTypeLoading = false;
            });
    },
});

export default vehicleTypeSlice.reducer;
